import {
  ConfirmationDialog,
  ErpDataTableV2,
  ErpInputTableV2,
  AritoIcon,
  BulkDeleteDialogV4,
  ExcelImportDialog,
  ExcelImportErrorDialog
} from '@/components/custom/erp';
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '@/components/ui/resizable';
import { HoaDonMuaHangTrongNuocSearchProvider, useHoaDonMuaHangTrongNuocPage } from './context';

import { INPUT_TABLE_COLUMNS } from './cols-definition';
import SearchDialog from './components/search-dialog';
import FormDialog from './components/form-dialog';
import ActionBar from './components/ActionBar';
import { TABLE_PAGE_SIZE } from './constants';

function HoaDonMuaHangTrongNuocPageContent() {
  const page = useHoaDonMuaHangTrongNuocPage();

  return (
    <div className='flex h-screen w-full flex-col overflow-hidden'>
      {page.searchDialog.open && (
        <SearchDialog
          open={page.searchDialog.open}
          onClose={page.searchDialog.onClose}
          onSearch={page.searchDialog.onSubmit}
          searchParams={page.searchDialog.searchParams}
          searchFieldState={page.searchDialog.searchFieldState}
          searchFieldActions={page.searchDialog.searchFieldActions}
        />
      )}

      {page.importErrorDialog.open && page.importErrorDialog.errorData && (
        <ExcelImportErrorDialog
          open={page.importErrorDialog.open}
          onClose={page.importErrorDialog.onClose}
          errors={page.importErrorDialog.errorData.errors}
          columnMapping={page.importErrorDialog.errorData.columnMapping}
        />
      )}

      {page.importDialog.open && (
        <ExcelImportDialog
          open={page.importDialog.open}
          onClose={page.importDialog.closeDialog}
          onSubmit={page.importDialog.onSubmit}
          title='Lấy dữ liệu từ excel'
          titleIcon={<AritoIcon icon={555} />}
        />
      )}

      {page.formDialog.open && (
        <FormDialog
          formMode={page.formDialog.formMode}
          open={page.formDialog.open}
          onClose={page.formDialog.onClose}
          initialData={
            page.formDialog.formMode === 'add' && !page.formDialog.isCopyMode ? undefined : page.formDialog.detail
          }
          onSubmit={page.formDialog.onSubmit}
          onAdd={page.formDialog.onAdd}
          onEdit={page.formDialog.onEdit}
          onDelete={page.formDialog.onDelete}
          onCopy={page.formDialog.onCopy}
        />
      )}

      {page.bulkDeleteDialog.open && (
        <BulkDeleteDialogV4
          title='Hoá đơn mua hàng trong nước'
          onClose={page.bulkDeleteDialog.onClose}
          columns={page.table.columns}
          dataRows={page.table.displayData}
          handleDeleteMany={page.bulkDeleteDialog.onDelete}
        />
      )}

      {page.deleteDialog.open && (
        <ConfirmationDialog
          open={page.deleteDialog.open}
          onClose={page.deleteDialog.onClose}
          onConfirm={page.deleteDialog.onConfirm}
        />
      )}

      <div className={`flex h-full flex-col ${page.formDialog.open ? 'hidden' : ''}`}>
        <ActionBar
          onAdd={page.actions.handleAddClick}
          onEdit={page.actions.handleEditClick}
          onDelete={page.actions.handleDeleteClick}
          onCopy={page.actions.handleCopyClick}
          onSearch={page.actions.handleSearch}
          onRefresh={page.actions.handleRefresh}
          onImportExcel={page.importDialog.openDialog}
          isEditDisabled={!page.selection.selectedObj}
        />

        <div data-excel-operation-overlay-root className='min-h-0 flex-1 overflow-hidden'>
          <ResizablePanelGroup direction='vertical' className='h-full overflow-hidden'>
            <ResizablePanel defaultSize={55} minSize={20}>
              <div data-perf-id='hdmh-tn-master-table' className='h-full w-full overflow-hidden'>
                <ErpDataTableV2
                  tables={page.table.tables}
                  onRowClick={page.actions.handleRowClick}
                  onRowDoubleClick={params => page.actions.handleViewClick(params.row)}
                  rowContextMenu={{
                    onView: params => page.actions.handleViewClick(params.row)
                  }}
                  selectedRowId={page.selection.selectedRowIndex || undefined}
                  totalItems={page.table.totalItems}
                  currentPage={page.table.currentPage}
                  onPageChange={page.table.onPageChange}
                  onSearchChange={page.table.onSearchChange}
                  pageSize={TABLE_PAGE_SIZE}
                  loading={page.table.displayIsLoading || page.importDialog.isImporting}
                />
              </div>
            </ResizablePanel>

            <ResizableHandle withHandle className='bg-slate-200/80 hover:bg-slate-300' />

            <ResizablePanel defaultSize={45} minSize={20}>
              <div data-perf-id='hdmh-tn-bottom-detail-table' className='h-full overflow-hidden'>
                <ErpInputTableV2
                  rows={page.selection.selectedObj ? page.detailTable.rows : []}
                  columns={INPUT_TABLE_COLUMNS}
                  showIndexColumn
                  actions={{
                    export: () => console.log('Export clicked'),
                    pin: () => console.log('Pin clicked')
                  }}
                  actionsDisabled={page.formDialog.formMode === 'view' || !page.selection.selectedObj}
                  height='100%'
                  loading={page.table.displayIsLoading && !page.selection.selectedObj}
                />
              </div>
            </ResizablePanel>
          </ResizablePanelGroup>
        </div>
      </div>
    </div>
  );
}

export default function HoaDonMuaHangTrongNuocPage() {
  return (
    <HoaDonMuaHangTrongNuocSearchProvider>
      <HoaDonMuaHangTrongNuocPageContent />
    </HoaDonMuaHangTrongNuocSearchProvider>
  );
}
